import styled from 'styled-components';
import TooltipBubble from './TooltipBubble';

const TooltipTop = styled(TooltipBubble)`
  bottom: 100%;
  left: 50%;
  padding-bottom: 9px;
  transform: translateX(-50%);

  &:after {
    border-left: 9px solid transparent;
    border-right: 9px solid transparent;
    border-top: 9px solid rgba(0, 0, 0, 0.7);
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }
`;

export default TooltipTop;
